import client from '@/api/client'

async function getFenixUser ({ username }) {
  const response = await client.get(`/external-users/${username}`)
  return {
    user: response.data
  }
}

async function addService ({ service }) {
  const response = await client.post('services', service)
  return {
    service: response.data
  }
}

async function deleteService ({ serviceID }) {
  await client.delete(`services/${serviceID}`)
  return null
}

async function editService ({ serviceID, service }) {
  const response = await client.put(`services/${serviceID}`, service)
  return {
    service: response.data
  }
}

async function getService (service) {
  const response = await client.get(`/services/${service}`)
  return {
    service: response.data
  }
}

async function changeServiceStatus ({ service, active }) {
  const response = await client.put(`/services/${service}/status`, {
    active: active,
    printer: active,
    online: false
  })
  return { status: response.status }
}

async function statusOnlineTickets ({ service, online }) {
  const response = await client.put(`/services/${service}/status`, {
    active: true,
    printer: true,
    online: online
  })
  return {
    queue: response.data
  }
}

async function statusPrintTickets ({ service, printer }) {
  const response = await client.put(`/services/${service}/status`, {
    active: true,
    printer: printer,
    online: printer
  })
  return {
    queue: response.data
  }
}

async function getProfile () {
  const response = await client.get(`/profile`)
  return {
    loggedUser: response.data
  }
}

async function getServiceWorker (service, username) {
  const response = await client.get(`/services/${service}/workers/${username}`)
  return {
    worker: response.data
  }
}

async function getServiceWorkers (service) {
  const response = await client.get(`/services/${service}/workers`)
  return {
    workers: response.data
  }
}

async function deleteServiceWorker (service, worker) {
  const response = await client.delete(`/services/${service}/workers/${worker}`)
  if (response.status === 204) {
    return true
  }
  return false
}

async function createServiceWorker (service, username) {
  const response = await client.post(`/services/${service}/workers`, {
    username: username
  })
  if (response.status === 201) {
    return { calledTicket: response.data }
  }
  return null
}

async function updateDevice ({ service, deviceID }) {
  const response = await client.put(`/devices/${deviceID}`, {
    serviceID: service
  })
  return { device: response.data }
}

async function deleteDevice ({ deviceID }) {
  let response
  response = await client.delete(`/devices/${deviceID}`)
  return { device: response.data }
}

async function getNextTicket ({ service }) {
  let response = await client.get(`/services/${service}/next-ticket`)
  return {
    nextTicket: response.data
  }
}

async function getTicketsWaitingCount (service) {
  let response = await client.get(`/services/${service}/waiting-tickets-count`)
  return {
    ticketsWaitingCount: response.data
  }
}

async function getNextTickets ({ serviceID }) {
  let response = await client.get(`/services/${serviceID}/next-tickets`)
  return {
    nextTickets: response.data
  }
}

async function getCurrentTicket (service) {
  const response = await client.get(`/services/${service}/current-ticket`)
  return {
    ticket: response.data
  }
}

async function getPausedTickets ({ service }) {
  const response = await client.get(`/services/${service}/paused-tickets`)
  if (response.status === 200) {
    return { tickets: response.data }
  } else {
    return { tickets: null }
  }
}

async function enableQueue ({ service, queueSlug }) {
  const response = await client.put(
    `/services/${service}/queues/${queueSlug}/status`,
    { enabled: true }
  )
  return {
    queue: response.data
  }
}

async function disableQueue ({ service, queueSlug }) {
  const response = await client.put(
    `/services/${service}/queues/${queueSlug}/status`,
    { enabled: false }
  )
  return {
    queue: response.data
  }
}

async function updateQueue ({ service, queueSlug, queue }) {
  const response = await client.put(
    `/services/${service}/queues/${queueSlug}`,
    {
      letter: queue.letter,
      name: queue.name,
      enabled: true
    }
  )
  if (response.status === 200) {
    return {
      queue: response.data
    }
  }
  return null
}

async function deleteQueue ({ service, queueSlug }) {
  const response = await client.delete(
    `/services/${service}/queues/${queueSlug}`
  )
  if (response.status === 204) {
    return true
  }
  return false
}

async function createQueue (service, queueSlug, namePt, nameEn) {
  const response = await client.post('/services/' + service + '/queues', {
    letter: queueSlug,
    name: {
      pt: namePt,
      en: nameEn
    },
    enabled: true
  })
  if (response.status === 201) {
    return { ticket: response.data }
  } else {
    return { ticket: null }
  }
}

async function listServices () {
  const response = await client.get('/services')
  return { services: response.data }
}

export default {
  getFenixUser,
  addService,
  deleteService,
  editService,
  deleteDevice,
  getService,
  statusOnlineTickets,
  statusPrintTickets,
  changeServiceStatus,
  getPausedTickets,
  getCurrentTicket,
  enableQueue,
  disableQueue,
  updateQueue,
  deleteQueue,
  getServiceWorker,
  getServiceWorkers,
  createServiceWorker,
  deleteServiceWorker,
  updateDevice,
  getProfile,
  getNextTicket,
  getTicketsWaitingCount,
  getNextTickets,
  createQueue,
  listServices
}
